// Number and orientation formatting for display. GPL-3.0-or-later.
import * as S from "@dipfield/stereo";

export const fmt = (x: number | null | undefined, d = 1) => (x != null && Number.isFinite(x) ? x.toFixed(d) : "–");
export const pad3 = (x: number) => String(Math.round(x) % 360).padStart(3, "0");
export const pad2 = (x: number) => String(Math.round(x)).padStart(2, "0");
export const int = (n: number) => n.toLocaleString("en-US");

/** A plane written in the project's orientation format, e.g. "329/85". */
export function fmtPlane(dip: number, dd: number, f: S.OrientationFormat) {
  const [a, b] = S.planeToFormat(dip, dd, f);
  return f === "dip-dipdir" ? `${pad2(a)}/${pad3(b)}` : `${pad3(a)}/${pad2(b)}`;
}
/** "Dip/Dip dir", "Strike/Dip", ... */
export const fmtName = (f: S.OrientationFormat) => S.FORMAT_LABELS[f][1] + "/" + S.FORMAT_LABELS[f][2];
